import React, { useRef, useState, useEffect, ReactElement } from "react";
import { useLockFn } from "ahooks";
import { Table, Button } from "antd";
import { YhForm } from "@components/YhFormBox";
import { YhBox } from "@src/components/YhBox";
import { ContractRenewDrawer } from "./ContractRenewDrawer";
import { ColumnsType } from "antd/es/table";
import { useNavModel, RouterParamType } from "@src/model/navModel";
import { FormItemTypeEnum, IYhForm, IYhFormRef } from "@components/YhFormBox/Types";
import { getBaseImgUploadUrl, getBaseUploadData, getBaseImgLookUrl } from "@src/utils/constants";
import { rosterDetailsModels } from "./rosterDetailsModels";
import { rosterService } from "../../rosterService";
import { globalPrompt } from "@src/components/YhMessage";
import moment from "moment";
import YhUploadTable from '@src/components/YhUploadTable';
import useGlobalModel from "@src/model/globalModel";

export const ContractInfo: React.FC = (): ReactElement => {
  const { user } = useGlobalModel()
  const { getSelectedNavState } = useNavModel();
  const [detailsInfo] = useState<RouterParamType>(getSelectedNavState() as RouterParamType);
  const { id, mode } = detailsInfo;
  const {
    loadDs, getDetail, getFormInfo, onCancel,
    contraceHoldTypeDs, contraceTypeDs, socialSecurityTypeDs,
    contract, contracts, setContracts,
  } = rosterDetailsModels();
  const [renewVisible, setRenewVisible] = useState<boolean>(false);

  useEffect(() => {
    loadDs("contractInfo");
    if (mode === "edit") {
      getDetail(id, mode);
    }
  }, [detailsInfo]);


  const formRef = useRef<IYhFormRef>();
  const formConfig: IYhForm = {
    formRef,
    labelCol: { span: 9 },
    disabled: false,
    initialValues: contract,
    justify: 'start',
    items: [
      {
        type: FormItemTypeEnum.Input,
        fieldLabel: "",
        fieldName: "id",
        hidden: true,
      },
      {
        type: FormItemTypeEnum.Select,
        fieldLabel: "合同类型",
        fieldName: "contractType",
        span: 6,
        rules: [{ required: true, message: '该项为必填项' }],
        ds: contraceTypeDs
      },
      {
        type: FormItemTypeEnum.Select,
        fieldLabel: "合同户别",
        fieldName: "contractCategory",
        span: 6,
        rules: [{ required: true, message: '该项为必填项' }],
        ds: contraceHoldTypeDs
      },
      {
        type: FormItemTypeEnum.Select,
        fieldLabel: "社保户别",
        fieldName: "socialSecurityType",
        span: 6,
        ds: socialSecurityTypeDs
      },
      {
        type: FormItemTypeEnum.Select,
        fieldLabel: "是否长期",
        fieldName: "isLongTerm",
        span: 6,
        ds: [{ label: "否", value: 0 }, { label: "是", value: 1 }]
      },
      {
        type: FormItemTypeEnum.Input,
        fieldLabel: "续签次数",
        fieldName: "num",
        span: 6,
      },
      {
        type: FormItemTypeEnum.Input,
        fieldLabel: "合同期限",
        fieldName: "contractDuration",
        span: 6,
      },
      {
        type: FormItemTypeEnum.Datepicker,
        format: "YYYY-MM-DD",
        fieldLabel: "当前合同开始",
        fieldName: "startDate",
        span: 6,
      },
      {
        type: FormItemTypeEnum.Datepicker,
        format: "YYYY-MM-DD",
        fieldLabel: "当前合同结束",
        fieldName: "endDate",
        span: 6,
      }
    ]
  };

  const columns: ColumnsType<any> = [
    {
      align: "center",
      title: "合同类型",
      width: 80,
      dataIndex: "contractType",
      render: (v: any, r: any, i: any) => {
        const item = contraceTypeDs?.find(item => item.value === v);
        return <span style={{ lineHeight: '28px' }}>{item?.label || v}</span>;
      },
    },
    {
      align: "center",
      title: "合同户别",
      width: 150,
      dataIndex: "contractCategory",
      render: (v: any, r: any, i: any) => {
        const item = contraceHoldTypeDs?.find(item => item.value === v);
        return <span style={{ lineHeight: '28px' }}>{item?.label || v}</span>;
      },
    },
    {
      align: "center",
      title: "社保户别",
      width: 150,
      dataIndex: "socialSecurityType",
      render: (v: any, r: any, i: any) => {
        const item = socialSecurityTypeDs?.find(item => item.value === v);
        return <span style={{ lineHeight: '28px' }}>{item?.label || v}</span>;
      },
    },
    {
      align: "center",
      title: "是否长期",
      width: 80,
      dataIndex: "isLongTerm",
      render: (v: any) => <span style={{ lineHeight: '28px' }}>{v === 1 ? '是' : '否'}</span>,
    },
    {
      align: "center",
      title: "合同签订开始时间",
      width: 100,
      dataIndex: "startDate",
      render: (v: any) => <span style={{ lineHeight: '28px' }}>{v ? moment.isMoment(v) ? v.format('YYYY-MM-DD') : v : '-'}</span>,
    },
    {
      align: "center",
      title: "合同签订结束时间",
      width: 100,
      dataIndex: "endDate",
      render: (v: any) => <span style={{ lineHeight: '28px' }}>{v ? moment.isMoment(v) ? v.format('YYYY-MM-DD') : v : '-'}</span>,
    },
    {
      align: "center",
      title: "合同年限",
      width: 50,
      dataIndex: "contractDuration",
      render: (v: any, r: any, i: any) => <span style={{ lineHeight: '28px' }}>{v}</span>,
    },
    {
      align: "center",
      title: "相关文件",
      width: 80,
      dataIndex: "file",
      render: (value: any, row: any, index: any) => {
        return <div className="contractFileStyle" style={{ height: 70 }}>
          <YhUploadTable
            action={getBaseImgUploadUrl()}
            uploadData={getBaseUploadData()}
            initialValue={row.userFileList}
            listType="picture-card"
            maxCount={1}
            fileUrl={getBaseImgLookUrl}
            rowId={row.id}
            onUpdateRow={(rowId, file, fileList) => {
              // 更新当前行
              const newData = [...contracts];
              const rowIndex = newData.findIndex(item => item.id === rowId);
              if (rowIndex > -1) {
                newData[rowIndex] = {
                  ...newData[rowIndex],
                  userFileList: fileList
                };
                setContracts(newData);
              }
            }}
          />
        </div>
      }
    },
    {
      align: "center",
      title: "操作时间",
      width: 100,
      dataIndex: "contractsData",
      render: (v: any, r: any, i: any) => <span style={{ lineHeight: '28px' }}>{v}</span>,
    },
    {
      align: "center",
      title: "操作人",
      width: 50,
      dataIndex: "operator",
      render: (v: any, r: any, i: any) => <span style={{ lineHeight: '28px' }}>{v}</span>,
    }
  ];

  const onSave = useLockFn(async () => {
    try {
      const formData = await formRef.current?.validateFields();
      let contractsData = [{
        ...formData,
        num: formData?.num ?? 0,
        operator: (formData?.operator ?? user.userName)
      }];
      if (contracts != null && contracts.length > 0) {
        contractsData = contracts?.map((item: any) => {
          if (item.id === formData?.id) {
            return { ...item, ...formData };
          } else {
            return item;
          }
        });
      }
      if (formData) {
        const params = {
          employeeId: id,
          userContractsInsertVoList: contractsData?.map((item: any) => ({
            ...item,
            startDate: item.startDate ? moment(item.startDate).format("YYYY-MM-DD") : null,
            endDate: item.endDate ? moment(item.endDate).format("YYYY-MM-DD") : null,
          }))
        }
        let ret = await rosterService.contractInsert(params);
        if (ret.success) {
          await globalPrompt("message", { type: "success", text: '保存成功!' });
          getDetail(id, mode);
        } else {
          await globalPrompt("message", { type: "error", text: "保存失败!" + ret.retMsg });
        }
      }
    } catch (e) {
      console.log("保存失败!", e);
    }
  });

  const action = (
    <>
      <Button className="mr-5" type="link" shape="round" onClick={() => { onSave() }}>保存</Button>
      <Button className="mr-5" type="link" shape="round" onClick={() => setRenewVisible(true)}>续签</Button>
      <Button className="mr-5" type="link" shape="round" onClick={() => { onCancel(mode) }}>取消</Button>
    </>
  );

  return (
    <>
      <YhBox action={action} style={{ overflowY: 'auto', padding: 10, margin: 10 }}>
        <div style={{ padding: 10, fontSize: 18, fontWeight: "bold" }}>合同信息</div>
        <YhForm  {...formConfig} />

        <div style={{ marginTop: 10, padding: 10, fontSize: 18, fontWeight: "bold" }}>合同记录</div>
        <div className="contractTableStyle">
          <Table
            rowKey={(record, index) => record.id}
            columns={columns}
            dataSource={contracts}
            scroll={{ x: "max-content" }}
            pagination={false}
          />
        </div>
      </YhBox>

      <ContractRenewDrawer visible={renewVisible} userInfo={getFormInfo(mode)} onCancel={() => { getDetail(id, mode); setRenewVisible(false); }} />
    </>
  );
}